import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Empty from '../../../common/components/utils/Empty';
import ModulesGroup from '../../../common/components/utils/ModuleAccessBar/ModulesGroup';
import Spinner from '../../../common/components/utils/Spinner';
import useQuickAccessActions from './useQuickAccessActions';
const ModulesGroupsBar = ({ input, groups }) => {
    const { handleDragEnd, localGroups, handleClick } = useQuickAccessActions({
        groups,
        input,
    });
    if (!input.value) {
        return <Spinner inline={false}/>;
    }
    if (localGroups.length > 0) {
        return (<DragDropContext onDragEnd={handleDragEnd}>
        {localGroups.map(group => (<ModulesGroup key={`group-${group.id}`} accessItems={input.value} group={group} onClick={handleClick} onDragEnd={handleDragEnd}/>))}
      </DragDropContext>);
    }
    return <Empty key="filter-message"/>;
};
export default ModulesGroupsBar;
